import {
  Button,
  CircularProgress,
  createStyles,
  makeStyles,
  Theme,
} from "@material-ui/core";
import { green } from "@material-ui/core/colors";
import React, { FC } from "react";

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    wrapper: {
      //margin: theme.spacing(1),
      position: "relative",
    },
    buttonProgress: {
      color: green[500],
      position: "absolute",
      top: "50%",
      left: "50%",
      marginTop: -12,
      marginLeft: -12,
    },
    buttonClassname: {
      height: 56,
      width: "100%",
    },
  })
);

interface Props {
  pending: boolean;
  text: string;
  update: () => void;
}

const LoadingButton: FC<Props> = ({ pending, text, update }) => {
  const classes = useStyles();

  return (
    <div className={classes.wrapper} key={"" + pending}>
      <Button
        fullWidth
        variant="contained"
        color="primary"
        className={classes.buttonClassname}
        onClick={update}
        disabled={pending}
        type="submit"
      >
        {text}
      </Button>
      {pending && (
        <CircularProgress size={24} className={classes.buttonProgress} />
      )}
    </div>
  );
};

export default LoadingButton;
